import {Component, Input} from '@angular/core';

@Component({
    selector: 'collapse-link',
    providers: [],
    template: `
        <div>
            <a href="javascript:;" class="link-dashed link-dashed-dropdown collapsed" (click)="toggle()">{{title}}</a>
            <div [class.hidden] = "!opened" style="padding-top: 5px">
                <ng-content></ng-content>
            </div>
        </div>`
})
export class CollapseLinkComponent {
    @Input() opened = false;
    @Input() title = '';

    toggle() {
        this.opened = !this.opened;
    }
}
